import { addScriptInDom } from './addScriptInDom';
export function loadScript(src, onload, onerror) {
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    if (onload)
        script.onload = onload;
    if (onerror)
        script.onerror = onerror;
    addScriptInDom(script);
    return script;
}
